import SeanLam from "../Assets/SeanLam.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img className="card-img-style" src={SeanLam} alt="judge picture"></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Sean Lam</h2>
        <br />
        <p className="card-sub-name-style">
          Deputy Director, SingHealth
          <br /> Duke NUS Academic Medical Centre
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />

            <h2>Sean Lam</h2>
            <br />
            <h3>
              Deputy Director, SingHealth Duke NUS Academic Medical Centre
            </h3>
            <br />
            <p>
              A/Prof Sean Lam has a PhD and Master’s in Industrial and Systems
              Engineering, Operations and Business Analytics from the National
              University of Singapore. He is currently the Deputy Director and
              Head (Data Science) in the SingHealth Duke-NUS Academic Medical
              Centre. Sean is with the Signature Programme in Health Services
              and Systems Research and the SingHealth Duke NUS Global Health
              Institute. He is also a Faculty Fellow with the Singapore
              Biodesign Programme. He has more than 80 international
              publications and recipient of numerous local and international
              awards.
              <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
